export default __webpack_public_path__ + "static/media/mailsend.ce2cf790.svg";